import BlBannerMv from './BlBannerMv.vue'

BlBannerMv.install = function(Vue) {
  Vue.component(BlBannerMv.name, BlBannerMv)
}

export default BlBannerMv
